import request from "@/utils/request";

// 列表(主数据列表)
export function loadIndepotBillListDataApi(data) {
  return request({
    url: "web/indepotBill/listData",
    method: "post",
    data
  });
}
// 导出
export function loadIndepotBillExportDataApi(data) {
  return request({
    url: "web/indepotBill/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateIndepotBillApi(data) {
  return request({
    url: "web/indepotBill/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initIndepotBillApi(data) {
  return request({
    url: "web/indepotBill/initIndepotBill",
    method: "post",
    data
  });
}

// 更新无方案的明细,关联方案
export function indepotBillUpdateNoSchemeItemApi(data) {
  return request({
    url: "web/indepotBill/updateNoSchemeItem",
    method: "post",
    data
  });
}

// 明细列表(主数据列表)
export function loadIndepotBillDetailListDataApi(data) {
  return request({
    url: "web/indepotBillDetail/listData",
    method: "post",
    data
  });
}
// 明细导出
export function loadIndepotBillDetailExportDataApi(data) {
  return request({
    url: "web/indepotBillDetail/exportData",
    method: "post",
    data
  });
}
// 根据入库单id初始化物料明细
export function initIndepotBillDetailApi(data) {
  return request({
    url: "web/indepotBillDetail/initIndepotBillDetail",
    method: "post",
    data
  });
}

// 无方案明细列表
export function loadIndepotBillListDetailNoSchemeDataApi(data) {
  return request({
    url: "web/indepotBillDetail/listDataByNoScheme",
    method: "post",
    data
  });
}
// 无方案明细导出
export function loadIndepotBillDetailNoSchemeExportDataApi(data) {
  return request({
    url: "web/indepotBillDetail/exportDataByNoScheme",
    method: "post",
    data
  });
}